module.exports = __webpack_public_path__ + "img/GameofBuckets.d8d65cfd.png";